import { connect } from 'react-redux';
import * as R from 'ramda';
import { setFilters } from 'feature/loading-management/filters/store/filtersSlice';
import {
  fetchAuthorizationSequencingDetails,
  getStoreValueByProp,
  updateAuthorizationSequencingDetails,
  updateSequence,
} from '../store/authorizationSequencingSlice';
import { setActiveSelfAuthTab } from '../../self-authorizations/store/selfAuthorizationsSlice';
import { setActiveSupplierAuthTab } from '../../supplier-authorizations/store/supplierAuthorizationSlice';
import { setActiveMyAuthTab } from '../../my-authorizations/store/myAuthorizationsSlice';

import EditPanel from '.';

const mapState = R.applySpec({
  details: getStoreValueByProp(['authorizationSequencingDetails']),
  detailsPending: getStoreValueByProp(['authorizationSequencingDetailsPending']),
});

const mapDispatch = {
  fetchAuthorizationSequencingDetails,
  setActiveMyAuthTab,
  setActiveSelfAuthTab,
  setActiveSupplierAuthTab,
  setFilters,
  updateAuthorizationSequencingDetails,
  updateSequence,
};
export default connect(mapState, mapDispatch)(EditPanel);
